import get from 'lodash.get';

const getCurrentColorPaletteVersion = (state) =>
  get(state, 'ws.site.meta.customization.currentColorPaletteVersion', null);

export default getCurrentColorPaletteVersion;
